import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"
import { SubscriptionDisplayName, SubscriptionEnum } from "./types";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function cookieCleanup() {
  document.cookie = 'admin_access_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;';
  localStorage.removeItem("user");
}

export function getSubscriptionDisplayName(subscriptions: string) {
  return subscriptions.split(',').map((subscription: string) => SubscriptionDisplayName[subscription.trim() as SubscriptionEnum])
  .join(', ');
}

export const validateEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};